import React from "react";
import { AppRouter } from "./app/router/AppRouter";

/**
 * Root App component.
 *
 * Keeps App.tsx minimal and delegates routing/auth/layout to `AppRouter`.
 */
export default function App() {
  return (
    <div className="min-h-screen w-full bg-[color:var(--kkp-bg)] text-[color:var(--kkp-text)]">
      <AppRouter />
    </div>
  );
}
